"use client";

import { LayoutType } from "../../types/enum";
import { FloatingMenu } from "./floating-menu";

interface LayoutWrapperProps {
  children: React.ReactNode;
  onLayoutChange: (layout: LayoutType) => void;
  removeBranding: boolean;
  layout?: LayoutType;
}

export function LayoutWrapper({
  children,
  onLayoutChange,
  removeBranding,
  layout = "default",
}: LayoutWrapperProps) {
  const isFullScreen = layout === "column";

  if (import.meta.env.MODE === "widget") {
    return (
      <div className="h-full bg-card border-0 shadow-none rounded-none sm:rounded-lg sm:border sm:shadow-sm">
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <main className={isFullScreen ? "h-screen" : "py-0 sm:py-8"}>
        <div
          className={
            isFullScreen
              ? "h-full"
              : "max-w-[1280px] mx-auto px-0 sm:px-4 mb-24"
          }
        >
          <div className="h-full bg-card border-0 shadow-none rounded-none sm:rounded-lg sm:border sm:shadow-sm">
            {children}
          </div>
        </div>
      </main>
      <FloatingMenu
        layout={layout}
        removeBranding={removeBranding}
        onLayoutChange={onLayoutChange}
      />
    </div>
  );
}
